import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "text-black text-body-2"
};
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
export default {
  __name: 'LlWarningBanner',
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    buttonText: {
      type: String,
      default: ''
    },
    bannerClass: {
      type: [String, Object, Array],
      default: ''
    }
  },
  emits: ['action'],
  setup(__props) {
    return (_ctx, _cache) => {
      return __props.visible ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["d-flex align-center justify-space-between rounded px-4 py-3 no-print", __props.bannerClass]),
        style: {
          backgroundColor: '#FCF8E3',
          marginBottom: '10px'
        }
      }, [_createElementVNode("span", _hoisted_1, [_renderSlot(_ctx.$slots, "default")]), __props.buttonText ? (_openBlock(), _createBlock(LlSecondaryButton, {
        key: 0,
        class: "ml-4 flex-shrink-0",
        onBtnClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('action'))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.buttonText), 1)]),
        _: 1
      })) : _createCommentVNode("", true)], 2)) : _createCommentVNode("", true);
    };
  }
};